export const SIZE = {
  BOTTOM_BAR_HEIGHT: 62,
  HEADER_HEIGHT: 50,
} as const;
